// extracted by mini-css-extract-plugin
module.exports = {"badge":"SortPriorityBadge_badge__3eUkE"};